<div id="file-popup" class="content k-p-3">
  <section>
    <form [formGroup]="assignProjectForm()">
      <div class="k-d-flex k-align-items-center k-justify-content-between">
        <h4 class="k-my-0 k-mr-4">Projekte</h4>
        <kendo-dropdownlist
          [showStickyHeader]="false"
          [data]="projectsDropdownItems()"
          textField="text"
          valueField="value"
          [formControlName]="formControlNames.Project"
        >
        </kendo-dropdownlist>
      </div>
      <div class="k-mt-2">
        <input type="checkbox" [formControlName]="formControlNames.UseColor" kendoCheckBox />
        <kendo-label class="k-checkbox-label" text="Projektfarbe übernehmen"> </kendo-label>
      </div>
      <button
        kendoButton
        class="k-ml-22 !k-pr-4 k-mt-5"
        themeColor="secondary"
        size="large"
        (click)="assignToProject()"
      >
        <fa-icon class="icon turquoise" size="xs" [icon]="faFileUpload"></fa-icon>
        Zuweisen
      </button>
    </form>
  </section>
</div>
